import { render } from "./AquaparkSpa.vue?vue&type=template&id=62a374e2"
import script from "./AquaparkSpa.vue?vue&type=script&lang=js"
export * from "./AquaparkSpa.vue?vue&type=script&lang=js"

import "./AquaparkSpa.vue?vue&type=style&index=0&id=62a374e2&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__